import React from 'react';
import AudioBookItem from '../../components/AudioBookItem/AudioBookItem';
import style from './ElearningSection.module.css';
import mediaItems from '../../jsons/elearning.json'


const ElearningSection = () => {

  return (
    <div className={style.ElearningSectionContainer}>
      {mediaItems.map((item, index) => (
        <AudioBookItem
          key={index}
          type={item.type}
          audioImg={item.image}
          audio={item.source}
        />
      ))}
    </div>
  );
};

export default ElearningSection;
